/* Header pop-ups: "Your city" picker (Pakistan) and the "Talk to an expert" help panel.
   - City is remembered in localStorage and shown in the header.
   - Chat button opens whichever live-chat app is installed, or falls back to WhatsApp / the contact page. */
(function () {
  'use strict';

  var CITIES = [
    ['Abbottabad', 'Khyber Pakhtunkhwa'], ['Badin', 'Sindh'], ['Bahawalpur', 'Punjab'], ['Bannu', 'Khyber Pakhtunkhwa'],
    ['Chitral', 'Khyber Pakhtunkhwa'], ['D.G. Khan', 'Punjab'], ['Dadu', 'Sindh'], ['Dir', 'Khyber Pakhtunkhwa'],
    ['Faisalabad', 'Punjab'], ['Gilgit', 'Gilgit-Baltistan'], ['Gujranwala', 'Punjab'], ['Gwadar', 'Balochistan'],
    ['Hyderabad', 'Sindh'], ['Islamabad', 'Islamabad Capital Territory'], ['Jacobabad', 'Sindh'], ['Karachi', 'Sindh'],
    ['Khairpur', 'Sindh'], ['Lahore', 'Punjab'], ['Larkana', 'Sindh'], ['Lasbela', 'Balochistan'],
    ['Mansehra', 'Khyber Pakhtunkhwa'], ['Multan', 'Punjab'], ['Murree', 'Punjab'], ['Nawabshah', 'Sindh'],
    ['Peshawar', 'Khyber Pakhtunkhwa'], ['Quetta', 'Balochistan'], ['Rahim Yar Khan', 'Punjab'], ['Rawalpindi', 'Punjab'],
    ['Sahiwal', 'Punjab'], ['Sheikhupura', 'Punjab'], ['Skardu', 'Gilgit-Baltistan'], ['Sukkur', 'Sindh'],
    ['Swat', 'Khyber Pakhtunkhwa'], ['Thatta', 'Sindh'], ['Turbat', 'Balochistan'], ['Ziarat', 'Balochistan']
  ];
  var ALIASES = {
    'dg khan': 'D.G. Khan', 'dera ghazi khan': 'D.G. Khan', 'd g khan': 'D.G. Khan', 'ryk': 'Rahim Yar Khan',
    'pindi': 'Rawalpindi', 'nawab shah': 'Nawabshah', 'benazirabad': 'Nawabshah', 'sheikhpura': 'Sheikhupura',
    'gujrawala': 'Gujranwala', 'peshwar': 'Peshawar', 'lahor': 'Lahore', 'khi': 'Karachi', 'isb': 'Islamabad'
  };
  var POPULAR = ['Lahore', 'Karachi', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Peshawar'];
  var STORE_KEY = 'tc_city';

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v == null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) {} }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }

  var pops = document.querySelectorAll('[data-hdr-pop]');
  if (!pops.length) return;

  /* ---------- open / close ---------- */
  function closeAll(except) {
    for (var i = 0; i < pops.length; i++) {
      if (pops[i] === except) continue;
      var b = pops[i].querySelector('[data-hdr-pop-btn]');
      var p = pops[i].querySelector('.hdr-panel');
      if (p && !p.hidden) { p.hidden = true; if (b) b.setAttribute('aria-expanded', 'false'); }
    }
  }
  function toggle(pop) {
    var b = pop.querySelector('[data-hdr-pop-btn]');
    var p = pop.querySelector('.hdr-panel');
    var open = p.hidden;
    closeAll(pop);
    p.hidden = !open;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var first = p.querySelector('input, [data-help-first]');
      if (first) setTimeout(function () { first.focus(); }, 30);
    }
  }
  Array.prototype.forEach.call(pops, function (pop) {
    var b = pop.querySelector('[data-hdr-pop-btn]');
    if (b) b.addEventListener('click', function (e) { e.stopPropagation(); toggle(pop); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-hdr-close]')) { closeAll(null); return; }
    for (var i = 0; i < pops.length; i++) if (pops[i].contains(e.target)) return;
    closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    for (var i = 0; i < pops.length; i++) {
      var p = pops[i].querySelector('.hdr-panel');
      if (p && !p.hidden) {
        closeAll(null);
        var b = pops[i].querySelector('[data-hdr-pop-btn]');
        if (b) b.focus();
        return;
      }
    }
  });

  /* ---------- city picker ---------- */
  var cityPop = document.querySelector('[data-hdr-pop="city"]');
  if (cityPop) {
    var input = cityPop.querySelector('#tc-city-input');
    var list = cityPop.querySelector('#tc-city-list');
    var hint = cityPop.querySelector('[data-city-hint]');
    var saveBtn = cityPop.querySelector('[data-city-save]');
    var clearBtn = cityPop.querySelector('[data-city-clear]');
    var shopLink = cityPop.querySelector('[data-city-shop]');
    var chips = cityPop.querySelector('[data-city-chips]');
    var label = cityPop.querySelector('[data-city-label]');
    var pending = null;
    var activeIdx = -1;
    var shown = [];
    var shopBase = (cityPop.getAttribute('data-shop-url') || '/collections/all');

    function canonical(text) {
      var n = norm(text);
      if (!n) return null;
      if (ALIASES[n]) return ALIASES[n];
      for (var i = 0; i < CITIES.length; i++) if (norm(CITIES[i][0]) === n) return CITIES[i][0];
      return null;
    }
    function shopUrl(city) {
      var sep = shopBase.indexOf('?') > -1 ? '&' : '?';
      return shopBase + sep + 'filter.p.m.filters.thrives_in=' + encodeURIComponent(city);
    }
    function render() {
      var saved = lsGet(STORE_KEY);
      if (label) label.textContent = saved ? saved + ' ▾' : 'Select city ▾';
      var cur = pending || saved;
      if (cur) {
        shopLink.hidden = false;
        shopLink.href = shopUrl(cur);
        shopLink.querySelector('span').textContent = cur;
      } else {
        shopLink.hidden = true;
      }
      clearBtn.hidden = !saved;
      saveBtn.disabled = !pending;
    }
    function setHint(text, ok) {
      hint.hidden = !text;
      hint.textContent = text || '';
      hint.classList.toggle('city-hint--ok', !!ok);
    }
    function hideList() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); activeIdx = -1; }
    function choose(city) {
      pending = city;
      input.value = city;
      hideList();
      setHint('');
      render();
    }
    function showMatches() {
      var q = norm(input.value);
      pending = canonical(input.value);
      shown = [];
      if (q) {
        var starts = [], contains = [];
        CITIES.forEach(function (c) {
          var n = norm(c[0]);
          if (n.indexOf(q) === 0) starts.push(c); else if (n.indexOf(q) > -1) contains.push(c);
        });
        Object.keys(ALIASES).forEach(function (a) {
          if (a.indexOf(q) === 0) {
            var c = CITIES.filter(function (x) { return x[0] === ALIASES[a]; })[0];
            if (c && starts.indexOf(c) === -1 && contains.indexOf(c) === -1) starts.push(c);
          }
        });
        shown = starts.concat(contains).slice(0, 8);
      }
      list.textContent = '';
      shown.forEach(function (c, i) {
        var li = el('li', 'city-item');
        li.id = 'tc-city-opt-' + i;
        li.setAttribute('role', 'option');
        li.appendChild(el('span', 'city-item__name', c[0]));
        li.appendChild(el('span', 'city-item__prov', c[1]));
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(c[0]); });
        list.appendChild(li);
      });
      if (shown.length) { list.hidden = false; input.setAttribute('aria-expanded', 'true'); setHint(''); }
      else {
        hideList();
        setHint(q ? 'We deliver across Pakistan. Pick the nearest city from the list for the best plant matches.' : '');
      }
      activeIdx = -1;
      render();
    }
    function setActive(i) {
      var items = list.querySelectorAll('.city-item');
      if (!items.length) return;
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-active', k === i);
      activeIdx = i;
      input.setAttribute('aria-activedescendant', items[i].id);
    }

    POPULAR.forEach(function (name) {
      var b = el('button', 'city-chip', name);
      b.type = 'button';
      b.addEventListener('click', function () { choose(name); });
      chips.appendChild(b);
    });

    function saveCity() {
      var c = pending || canonical(input.value);
      if (!c) { setHint('Please choose a city from the list.'); input.focus(); return; }
      lsSet(STORE_KEY, c);
      pending = null;
      input.value = c;
      render();
      setHint('Saved. Your city is now ' + c + '.', true);
      document.dispatchEvent(new CustomEvent('tc:city-changed', { detail: { city: c } }));
    }

    input.addEventListener('input', showMatches);
    input.addEventListener('focus', function () { if (input.value) showMatches(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) showMatches(); setActive(activeIdx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        if (!list.hidden && activeIdx > -1 && shown[activeIdx]) { choose(shown[activeIdx][0]); }
        else if (!list.hidden && shown.length === 1) { choose(shown[0][0]); }
        else { saveCity(); }
      }
    });
    saveBtn.addEventListener('click', saveCity);
    clearBtn.addEventListener('click', function () {
      lsSet(STORE_KEY, null);
      pending = null;
      input.value = '';
      setHint('');
      render();
      document.dispatchEvent(new CustomEvent('tc:city-changed', { detail: { city: null } }));
    });
    input.addEventListener('blur', function () { setTimeout(hideList, 120); });

    var savedCity = lsGet(STORE_KEY);
    if (savedCity) input.value = savedCity;
    render();
  }

  /* ---------- help panel: open the installed chat app ---------- */
  function openChat() {
    try {
      // Gladly Chat (documented API: Gladly.show())
      if (window.Gladly && typeof window.Gladly.show === 'function') { window.Gladly.show(); return true; }
      if (window.Tawk_API && window.Tawk_API.maximize) { window.Tawk_API.maximize(); return true; }
      if (window.tidioChatApi) { window.tidioChatApi.show(); window.tidioChatApi.open(); return true; }
      if (window.$crisp && window.$crisp.push) { window.$crisp.push(['do', 'chat:show']); window.$crisp.push(['do', 'chat:open']); return true; }
      if (typeof window.Intercom === 'function') { window.Intercom('show'); return true; }
      if (typeof window.zE === 'function') { window.zE('messenger', 'open'); return true; }
      if (window.GorgiasChat && window.GorgiasChat.open) { window.GorgiasChat.open(); return true; }
      if (window.LC_API && window.LC_API.open_chat_window) { window.LC_API.open_chat_window(); return true; }
      if (window.HubSpotConversations && window.HubSpotConversations.widget) { window.HubSpotConversations.widget.open(); return true; }
      if (window.$zopim && window.$zopim.livechat) { window.$zopim.livechat.window.show(); return true; }
      if (window.smartsupp) { window.smartsupp('chat:open'); return true; }
    } catch (e) { /* try the next option */ }
    try {
      // Shopify Inbox renders a web component with a shadow root
      var inbox = document.querySelector('inbox-online-store-chat');
      if (inbox && inbox.shadowRoot) {
        var btn = inbox.shadowRoot.querySelector('button, [role="button"]');
        if (btn) { btn.click(); return true; }
      }
    } catch (e2) { /* ignore */ }
    return false;
  }
  var chatBtn = document.querySelector('[data-help-chat]');
  if (chatBtn) {
    chatBtn.addEventListener('click', function (e) {
      if (openChat()) { e.preventDefault(); closeAll(null); }
      // otherwise the link's own href (WhatsApp or contact page) is used
    });
  }
})();
